import { domReady } from '../modules/utils.js';

class LogosSlider extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.#duplicateGroup();
  }

  #duplicateGroup() {
    const track = this.querySelector('.herohome-logos-track');
    const group = track?.querySelector('.herohome-logos-group');

    if (!track || !group) return;

    const clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  }
}

customElements.define('logos-slider', LogosSlider);
